module.exports = __webpack_public_path__ + "img/18.9ab0de95.jpg";